import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryEmpowerStatisticDetails (params) {
  return request({
    ...APIS['@analyzer/Query_Empower_StatisticDetails'],
    params
  })
}

export function queryEmpowerGrowthAnalysis (params) {
  return request({
    ...APIS['@analyzer/Query_Empower_GrowthAnalysis'],
    params
  })
}

export function queryIncomeGrowthAnalysis (params) {
  return request({
    ...APIS['@analyzer/Query_Income_GrowthAnalysis'],
    params
  })
}

export function queryIncomeStatisticDetails (params) {
  return request({
    ...APIS['@analyzer/Query_Income_StatisticDetails'],
    params
  })
}
